import React, { useEffect, useState } from 'react'
import { categoryService } from '../../services/category.service'

export function CategoryIcon ({ categorySelected, setCategorySelected, setCategoryName }) {
  const [categories, setCategories] = useState([])

  useEffect(() => {
    // Logica: Obtener categorias, peticion asincrona
    const getCategories = async () => {
      try {
        // Esperar a resolver la peticion para avanzar
        const dbCateogires = await categoryService.getAllCategories()
        setCategories(dbCateogires)
      } catch (error) {
        console.log(error)
      }
    }
    getCategories()
  }, [])

  function handleInput (category) {
    const index = category.id
    const name = category.nombre
    setCategorySelected(categorySelected === name ? 0 : name)
    setCategoryName(categorySelected === name ? null : name)
  }
  function getCategories () {
    return categories.map((category, index) => {
      return (
      <CategoryOption key={index} onClick={() => handleInput(category)} {...category} />
      )
    })
  }

  return (
    <div>
      {getCategories()}
    </div>
  )
}

const CategoryOption = (props) => {
  return (
    <button onClick={props.onClick} value={props.id_categoria} id={props.nombre} type="button" className="btn btn-primary button btn-sm fs-sm rounded px-2">
      {props.nombre}
    </button>
  )
}
